import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	fourOhFourHeading: {
		id: 'fastshift.common.displays.404-display.heading',
		defaultMessage: 'We can’t find the page you’re looking for',
		description: 'Heading for 404 display',
	},
	fourOhFourDescription: {
		id: 'fastshift.common.displays.404-display.description',
		defaultMessage: 'Go back to {404Link}',
		description: 'Description for 404 display',
	},
	fourOhFourLinkText: {
		id: 'fastshift.common.displays.404-display.link-text',
		defaultMessage: 'atlassian.com/fastshift',
		description: 'Link text for 404 display',
	},
	fourOhFourBackButtonText: {
		id: 'fastshift.common.displays.404-display.back-button-text',
		defaultMessage: 'Go to home',
		description: 'Back button text for 404 display',
	},
});
